<template>
  <div class="w-100 h-100 paper-background">
    <v-row class="holder fill-height py-16" align="center" justify="center">
      <Scribbles />
      <v-col cols="12" class="px-8 px-md-16">
        <v-row class="main-row fill-height w-100" align="center" justify="center">
        <v-col cols="12" lg="6" class="p-relative pb-lg-16">
          <h1 class="text-sans">
            <span class="p-relative">{{ $root.siteSettings.globalSiteTitle }}</span>
            <span>{{ $root.siteSettings.globalSiteTitle }}</span>
          </h1>
          <h1 class="text-sans">{{$root.siteSettings.globalSiteTitle}}</h1>
          <span class="text-script brackets">(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)</span>
        </v-col>
        <v-col cols="12" lg="6" class="text-sans pt-lg-16">
          <v-row class="description-holder" :data-teaser="$root.siteSettings.teaserLink !== null && $root.siteSettings.teaserLink.length">
            <v-col v-if="$root.siteSettings.teaserLink !== null && $root.siteSettings.teaserLink.length" cols="12" md="4" class="text-right">
              <v-row>
                <v-col class="text-right d-flex teaser-holder" cols="12">
                  <span class="teaser-title">
                    {{$root.siteSettings.teaserText}}
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="8">
              <v-row v-if="$root.siteSettings.teaserLink !== null && $root.siteSettings.teaserLink.length">
                <v-col justify="end" class="text-right" cols="4"><span class="opacity-5">{{$root.siteSettings.teaserShortName}}</span></v-col>
                <v-col justify="center" class="text-right text-md-center" cols="4">{{getTimeOnTimeZone($root.siteSettings.teaserTimeZones[0], $root.siteSettings.teaserFestivalDate)}}</v-col>
                <v-col justify="start" class="text-right text-md-left" cols="4">{{$root.siteSettings.teaserTimeZones[0]}}</v-col>
              </v-row>
              <v-row v-if="$root.siteSettings.teaserLink !== null && $root.siteSettings.teaserLink.length">
                <v-col justify="end" class="text-right" cols="4">{{new Date($root.siteSettings.teaserFestivalDate).toLocaleDateString($language.current, {month: 'long', day: 'numeric'})}}</v-col>
                <v-col justify="center" class="text-right text-md-center" cols="4">{{getTimeOnTimeZone($root.siteSettings.teaserTimeZones[1], $root.siteSettings.teaserFestivalDate)}}</v-col>
                <v-col justify="start" class="text-right text-md-left" cols="4">{{$root.siteSettings.teaserTimeZones[1]}}</v-col>
              </v-row>
              <v-row v-if="$root.siteSettings.teaserLink !== null && $root.siteSettings.teaserLink.length">
                <v-col justify="end" class="text-right" cols="4"><span class="opacity-5">{{new Date($root.siteSettings.teaserFestivalDate).toLocaleDateString($language.current, {year: 'numeric'})}}</span></v-col>
                <v-col justify="center" class="text-right text-md-center" cols="4">{{getTimeOnTimeZone($root.siteSettings.teaserTimeZones[2], $root.siteSettings.teaserFestivalDate)}}</v-col>
                <v-col justify="start" class="text-right text-md-left" cols="4">{{$root.siteSettings.teaserTimeZones[2]}}</v-col>
              </v-row>
              <v-row v-if="$root.siteSettings.teaserLink !== null && $root.siteSettings.teaserLink.length" class="w-100">
                <v-col class="text-right">
                  <a class="register ml-md-8 mt-4 mt-md-8" target="_blank" :href="$root.siteSettings.teaserLink">
                    <div class="icon animated-eye" />
                    <p class="text-script red--text mb-0 ml-3">Register</p>
                  </a>
                </v-col>
              </v-row>
              <v-row v-else class="w-100">
                <v-col class="text-right">
                  <div class="coming ml-md-16 mt-md-8">
                    <div class="icon animated-eye" />
                    <p class="text-script red--text mb-0 ml-3">Coming soon</p>
                  </div>
                </v-col>
              </v-row>

            </v-col>
          </v-row>
        </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Scribbles from '@/molecules/Scribbles'

const timeZonesDB = {
  CET: +1.00,
  EDT: -4.00,
  CST: -6.00
}

export default {
  name: 'TeaserPage',
  components: { Scribbles },
  methods: {
    getTimeOnTimeZone (timezone, date) {
      const targetTime = new Date(date)
      const timeZoneFromDB = timeZonesDB[timezone] // time zone value from database
      // get the timezone offset from local time in minutes
      const tzDifference = timeZoneFromDB * 60 + targetTime.getTimezoneOffset()
      // convert the offset to milliseconds, add to targetTime, and make a new Date
      return new Date(targetTime.getTime() + tzDifference * 60 * 1000).toLocaleTimeString(this.$language.current, { hour: '2-digit', minute: '2-digit' })
    }
  }
}
</script>

<style lang="scss" scoped>

.holder {
  overflow-x: hidden;
  margin: 0 auto;

  @include breakpoint(md-and-up) {
    max-width: 960px;
  }

  @include breakpoint(lg-and-up) {
    max-width: 1280px;
  }
}

.main-row {
  margin: 0 auto;
}

.description-holder {
  position: relative;
  @include breakpoint(md-and-up) {
    justify-content: flex-end;
  }

  &[data-teaser] {
    @include breakpoint(lg-and-up) {
      transform: translate(3vw, 80px);
    }
  }
}

.teaser-holder {
  justify-content: flex-end;
}

.teaser-title {
  display: block;
  width: 50%;
  @include breakpoint(lg-and-up) {
    width: 100%;
  }
}

h1 {
  position: relative;
  font-size: 3rem;
  line-height: 0.95;

  @include breakpoint(sm-and-up) {
    font-size: 5rem;
  }

  @include breakpoint(md-and-up) {
    font-size: 7rem;
    max-width: 860px;
  }

  @include breakpoint(lg-and-up) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 11.5rem;
  }

  &:nth-child(1) {
    opacity: 1;
    width: 180px;
    @include breakpoint(lg-and-up) {
      max-width: inherit;
      opacity: 0.15;
    }
  }

  &:nth-child(2) {
    display: none;
    @include breakpoint(lg-and-up) {
      display: block;
      clip-path: polygon(0 0, 26% 0%, 86% 0%, 95% 0%, 90% 65%, 80% 50%, 57% 55%, 47% 73%, 36% 85%, 14% 95%, 0 100%);
    }
  }

  > span {
    &:nth-child(1) {
      position: relative;
      clip-path: polygon(12% 0, 86% 1%, 99% 21%, 100% 23%, 93% 43%, 73% 53%, 52% 64%, 39% 97%, 35% 100%, 6% 100%, 0% 19%);
      display: block;

      @include breakpoint(lg-and-up) {
        clip-path: none;
      }
    }

    &:nth-child(2) {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0.15;
      @include breakpoint(lg-and-up) {
        display: none;
      }
    }
  }
}

.brackets {
  display: block;
  color: #e00;
  position: absolute;
  font-size: 1.1rem;
  top: 50%;
  left: 0%;
  transform: translate(45px, calc(100% - 10px));

  @include breakpoint(sm-and-up) {
    font-size: 2rem;
    transform: translate(68px, calc(100% - 30px));
  }

  @include breakpoint(md-and-up) {
    left: 50%;
    font-size: 2.5rem;
    transform: translate(-330px, calc(100% - 20px));
  }

  @include breakpoint(lg-and-up) {
    font-size: 4rem;
    transform: translate(-150px, calc(100% - 30px));
  }
}

.opacity-5 {
  opacity: 0.5;
}

.register,
.coming {

  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: none;
  background-color: transparent !important;
  transform: translate(30px, -30%);

  @include breakpoint(md-and-up) {
    justify-content: flex-start;
    transform: translate(60px, 0%);
  }

  &:hover {
    .icon {
      animation: eyeStop 1s steps(5) infinite alternate-reverse;
    }
  }

  .icon {
    position: relative;
    flex: 0 0 60px;
  }

  p {
    font-size: 1.15rem;
    white-space: nowrap;

    @include breakpoint(md-and-up) {
      font-size: 1.35rem;
    }

  }

}

.coming {
  @include breakpoint(lg-and-up) {
    transform: translateY(calc(100% + 80px));
  }
}

</style>
